import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-demande-service-cta",
  templateUrl: "./demande-service-cta.component.html",
  styleUrls: ["./demande-service-cta.component.scss"],
})
export class DemandeServiceCtaComponent {
  @Input() canSubmit = true;
  @Input() loading = false;

  @Output() submitPressed = new EventEmitter<void>();
  @Output() cancelPressed = new EventEmitter<void>();
}
